import { useContext, useState } from 'react';
import ButtonProccessing, { ButtonStatus } from '../Common/ButtonProccessing/ButtonProccessing';
import Money from '../Common/Money/Money';
import CreditCardList from '../CreditCard/CreditCardList';
import { useTranslation } from 'react-i18next';
import { payReservation, putReservation } from '../../services/reservations/reservationsService';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { WelletContext } from '../../context/WelletContext';
import styles from './paymentForm.module.css';
import ErrorBox from '../Common/ErrorBox/ErrorBox';

const PaymentForm = ({ reservation, products, lng }) => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const history = useHistory();
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [currentCardId, setCurrentCardId] = useState(null);
  const [error, setError] = useState(null);
  const [stripeErrorMessage, setStripeErrorMessage] = useState(null);

  const handleCardIdChange = (id) => {
    setCurrentCardId(id);
  };

  const pay = async (token, customer) => {
    setError('');
    setStripeErrorMessage('');

    const card = {
      cardId: currentCardId,
    };

    const pay = await payReservation(
      window.decodeURIComponent(token),
      card,
      customer,
      reservation.remainingDepositAmount,
      1,
      'EMAIL',
      welletContext,
    );

    if (pay.success) {
      setBtnStatus(ButtonStatus.ProgressFinished);
      setTimeout(() => {
        history.push(`/payment-success?token=${pay.tokenFile}`);
      }, 1000);
    } else {
      setBtnStatus('NORMAL');
      setError(pay.error);
    }
  };

  const handleSubmit = async () => {
    setBtnStatus(ButtonStatus.InProgress);
    const customer = {
      name: null,
      phone: null,
      email: null,
    };

    try {
      const result = await putReservation(
        reservation.show.id,
        reservation.pax,
        customer,
        null,
        null,
        null,
        reservation.event.startDate,
        reservation.depositAmount,
        products,
        null,
        reservation.event.id,
        null,
        null,
        null,
        null,
        null,
        welletContext,
      );

      pay(result.token, customer);
    } catch (error) {
      setError(t(error.message));
      setBtnStatus(ButtonStatus.Error);
    }
  };

  return (
    <>
      {error && (
        <div className='mb-3'>
          <ErrorBox title={error} />
        </div>
      )}
      <div className={styles.payContainer}>
        <CreditCardList onCardIdChange={handleCardIdChange} />

        <ButtonProccessing
          status={btnStatus}
          text={
            <>
              {t('pay')} <Money value={reservation.depositAmount} />
            </>
          }
          size='large'
          className={`mt-5`}
          type='submit'
          onClick={() => handleSubmit()}
          arrow
          color='#000'
          backgroundColor='var(--color-primary)'
          iconColor='#000'
        />
      </div>
    </>
  );
};

export default PaymentForm;
